const ES = {
    title: 'Posición link de pago',
    table: {
        title: 'Posición link de pago',
        generation: {
            text: 'Generación de links de pago: ',
            blocked: 'BLOQUEADA',
            enabled: 'HABILITADA',
        },
        columns: {
            totalMeasurementsSum: 'En el Mes',
            daily: 'Hoy',
        },
    }
};

export default ES;
